var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2028 7.84375C21.4266 7.26719 20.4356 6.8711 19.4128 6.71875C19.1025 4.88219 18.278 3.31235 17.0081 2.15078C15.6633 0.917971 13.8848 0.240158 12 0.240158C10.343 0.240158 8.8125 0.759533 7.57641 1.7425C6.63727 2.49026 5.9058 3.46657 5.45203 4.57797C4.04859 4.7936 2.77453 5.35985 1.82437 6.1975C0.630937 7.24985 0 8.65188 0 10.2527C0 11.8708 0.679219 13.3464 1.91203 14.4133C3.08953 15.43 4.67484 15.9902 6.375 15.9902H11.25V8.80094L9 11.0509L7.93922 9.99016L12 5.92985L16.0608 9.99016L15 11.0509L12.75 8.80094V15.9902H18.5625C20.0316 15.9902 21.3708 15.5777 22.3336 14.8291C23.4239 13.9806 24 12.7666 24 11.3214C24 9.91797 23.3784 8.71469 22.2028 7.84375ZM11.25 15.9902H12.75V19.7594H11.25V15.9902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3c8d258ff74d46079f607f026826b803.svg";
export { ForwardRef as ReactComponent };